__turbopack_context__.v({
  "AboutDrama": "page-module___8aEwW__AboutDrama",
  "Startwatch": "page-module___8aEwW__Startwatch",
  "TrendCard": "page-module___8aEwW__TrendCard",
  "TrendCardMove": "page-module___8aEwW__TrendCardMove",
  "bannerOuter": "page-module___8aEwW__bannerOuter",
  "bannerSec": "page-module___8aEwW__bannerSec",
  "circle": "page-module___8aEwW__circle",
  "container": "page-module___8aEwW__container",
  "dateTime": "page-module___8aEwW__dateTime",
  "dramaFeature": "page-module___8aEwW__dramaFeature",
  "dramaFeatureContent": "page-module___8aEwW__dramaFeatureContent",
  "dramaFeatureDesc": "page-module___8aEwW__dramaFeatureDesc",
  "dramaFeatureIg": "page-module___8aEwW__dramaFeatureIg",
  "dramaFeatureInner": "page-module___8aEwW__dramaFeatureInner",
  "dramaFeatureList": "page-module___8aEwW__dramaFeatureList",
  "dramaFeatureMob": "page-module___8aEwW__dramaFeatureMob",
  "dramaIgList": "page-module___8aEwW__dramaIgList",
  "dramaName": "page-module___8aEwW__dramaName",
  "dramaRelease": "page-module___8aEwW__dramaRelease",
  "form-group": "page-module___8aEwW__form-group",
  "maintitle": "page-module___8aEwW__maintitle",
  "newRelease": "page-module___8aEwW__newRelease",
  "rotateYLoop": "page-module___8aEwW__rotateYLoop",
  "rotateYLoopCenter": "page-module___8aEwW__rotateYLoopCenter",
  "sway": "page-module___8aEwW__sway",
  "swiper": "page-module___8aEwW__swiper",
  "trendingSec": "page-module___8aEwW__trendingSec",
  "viewAll": "page-module___8aEwW__viewAll",
  "viewAllLink": "page-module___8aEwW__viewAllLink",
  "watchDrama": "page-module___8aEwW__watchDrama",
  "watchDramaFlicks": "page-module___8aEwW__watchDramaFlicks",
  "watchDramaIg": "page-module___8aEwW__watchDramaIg",
  "watchDramaStore": "page-module___8aEwW__watchDramaStore",
  "watchDramaStoreDownload": "page-module___8aEwW__watchDramaStoreDownload",
  "watchDramaStoreGoogleDownload": "page-module___8aEwW__watchDramaStoreGoogleDownload",
  "whobblebtn": "page-module___8aEwW__whobblebtn",
});
